import React, { useEffect, useState, useRef } from 'react'
import ReactDOM from 'react-dom'
import styled from 'styled-components'

const TooltipContainerElement = styled.div`
  position: relative;
  display: inline-block;
`

const TooltipTextElement = styled.p`
  font-weight: 200 !important;
  font-size: 1rem !important;
  width: 200px;
  background-color: #444448;
  color: #fff;
  text-align: center;
  padding: 5px;
  position: absolute;
  z-index: 9999;
  overflow-wrap: break-word;
  top: ${({ position }) => `${position.top}px`};
  left: ${({ position }) => `${position.left}px`};
  transform: translateX(-50%);
  border-radius: 2px;

  &::after {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #444448 transparent;
  }
`

const TooltipText = ({ children, position }) =>
  ReactDOM.createPortal(
    <TooltipTextElement position={position}>{children}</TooltipTextElement>,
    document.body
  )

const DELTA_Y = -112

function PortalTooltip({ children, text }) {
  const containerRef = useRef()
  const [position, setPosition] = useState({ top: 0, left: 0 })
  const [isHovered, setIsHovered] = useState(false)

  useEffect(() => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect()
      setPosition({
        top: rect.bottom + window.scrollY + DELTA_Y,
        left: rect.left + rect.width / 2 + window.scrollX,
      })
    }
  }, [containerRef.current])

  return (
    <TooltipContainerElement
      innerRef={containerRef}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
      {text && isHovered && (
        <TooltipText position={position}>{text}</TooltipText>
      )}
    </TooltipContainerElement>
  )
}

export default PortalTooltip
